/**
 * Text and background of each status badge (spec 20261028-130000 AC-13). The text is the deep ink of the tone, not the
 * tone itself: at the badge's 11 px bold, `--success`, `--warning`, `--danger` and `--info` measured 3.15, 2.07, 3.44
 * and 3.38 on their soft backgrounds (2026-10-29), under the 4.5:1 that DESIGN.md §2.1 holds as non-negotiable.
 */
export const STATUS_TONES = {
  success: { fg: "successInkDeep", bg: "successSoft" },
  warning: { fg: "warningInkDeep", bg: "warningSoft" },
  danger: { fg: "dangerInkDeep", bg: "dangerSoft" },
  info: { fg: "infoInkDeep", bg: "infoSoft" },
} as const;
